define(function (require) {
    'use strict';

    var Marionette = require('marionette');
    var ProfileModel = require('models/profile');
    var AppConfig = require('config/application');

    return Backbone.Collection.extend({
        model: ProfileModel,
        url: '//' + AppConfig.host + '/rest/staff',

        parse: function (response) {
            if (response.result !== undefined) {
                return response.result.data;
            } else {
                return response;
            }
        },

        load: function () {
            var that = this;
            this.fetch({
                success: function () {
                    that.trigger('loaded');
                },
                error: function (collection, response, options) {
                    var resp = $.parseJSON(response.responseText);
                    if (resp.status == 0) {
                        app.message.error(resp.message || I18n.basic.oops);
                    }
                }
            });
        },

        comparator: function (collection) {
            return collection.get('sort')
        }

    });
});

